import { PermissionModel } from './permission.model';

export interface RoleModel {
   id: string;
   description: string;
   permissions: PermissionModel[];
}
